import { GenericPage } from "../components/common/GenericPage";
import {
  vehicleCollapseTableFields,
  vehicleTableFields,
} from "../utils/table-fields/vehicleTableFields";

export const AllVehicles = () => {
  return (
    <GenericPage
      title="All Vehicles"
      subtitle="Registry of planetary and atmospheric surface craft"
      parentQuery="allVehicles"
      childQuery="vehicles"
      tableFields={vehicleTableFields}
      collapseFields={vehicleCollapseTableFields}
    />
  );
};
